import React, {Component} from 'react';

import {ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import CircularProgress from 'material-ui/CircularProgress';
import Linkify from 'react-linkify';

import * as firebase from 'firebase';
import { connect } from 'react-redux';

class ChatMessageListItem extends Component {

  constructor () {
    super()
    this.state = {
      imageUrl: '',
    }
  }

  componentWillMount(){
    if(this.props.type === 'image'){
     this.getImageURL(this.props);
    }
  }

  componentWillReceiveProps(props){
    if (props.type === 'image'){
      this.getImageURL(props)
    }
  }

  getImageURL = (props) => {
    firebase.storage().ref().child(props.data.message.metadata.dbPath)
    .getDownloadURL()
    .then(imageUrl => {
      this.setState({imageUrl})
    })
  }

  render(){
    let content;
    const message = this.props.data.message;
    const nested = this.props.data.isSecondary; // TODO implement
    if (this.props.type === 'text'){

      content = (
        <ListItem
          disabled={true}
          innerDivStyle={{paddingTop: 0}}
          leftAvatar={
            <Avatar
              style={{borderRadius: 2}}
              backgroundColor={this.props.messageSender.color}  src="">
              {this.props.messageSender.displayName.substring(0, 1)}
            </Avatar>
          }>
          <div
            style={{
                  backgroundColor: 'transparent',
                  padding: 10,
                  paddingLeft: 0,
                  borderRadius: 5,
                }}
                >
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between'
                }}>
                <div>
                  {message.senderName}
                </div>

                <span
                  style={{
                    fontSize: 14,
                    color: '#a7abaf'
                  }}>
                  {this.props.data.timeStr}
                </span>
              </div>
              <div style= {{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginTop: 5,
                color:'#757575',
                whiteSpace: 'pre-line',
                textAlign: 'justify'}}>
                  <Linkify properties={{target: '_blank'}}>
                    {message.metadata.text}
                  </Linkify>
                  {
                    this.props.data.message.status === 'sent' && (
                      <CircularProgress
                          size={15} thickness={2} color='#527da3' style={{float: 'right'}}/>
                    )
                  }
              </div>
            </div>
          </div>
        </ListItem>
      )
    } else if (this.props.type === 'image'){

        content = (
          <ListItem
            innerDivStyle={{paddingTop: 8}}
            disabled={true}
            leftAvatar={
              <Avatar
                style={{borderRadius: 2}}
                backgroundColor={this.props.messageSender.color}  src="">
                {this.props.messageSender.displayName.substring(0, 1)}
              </Avatar>
            }>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
              <div>
                {message.senderName}
              </div>

              <span
                style={{
                  fontSize: 14,
                  color: '#a7abaf',
                }}>
                {this.props.data.timeStr}
              </span>
            </div>

            {
              this.state.imageUrl
              &&
              <img
                key={'img'}
                src={this.state.imageUrl}
                onClick={() => {
                  this.props.dispatch({
                    type: 'UI_DIALOG',
                    label: 'PHOTO_FULL_SCREEN',
                    value: {
                      disableDeletion: true,
                      imageUrl: this.state.imageUrl
                    }
                  })
                }}
                onLoad={this.props.scrollToBottom}
                style={{
                  display: 'flex',
                  cursor: 'pointer',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  height: 'auto',
                  width: 240,
                  marginTop: 10
                }}
                />
            }
            {
              this.props.data.message.status === 'sent' && (
                <CircularProgress
                  size={15} thickness={2} color='#527da3' style={{float: 'right'}}/>
              )
            }
          </ListItem>
        )
    } else if (this.props.type === 'date'){
      content = (
        <div>
          <ListItem
            disabled={true}
            primaryText={
              <div
                style={{fontSize: 15, fontWeight: 'bold' }}>
                {this.props.data.dayStr}
              </div>
            }/>
          <Divider inset={true} />
        </div>
      )
    }

    return (
      <div>
        {content}
      </div>
    )
  }

}

export default connect()(ChatMessageListItem)



// WEBPACK FOOTER //
// ./src/chat/ChatMessageListItem.js